import { render, staticRenderFns } from "./BaseMultiselect.vue?vue&type=template&id=6b0a3ec6&scoped=true"
import script from "./BaseMultiselect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMultiselect.vue?vue&type=script&setup=true&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BaseMultiselect.vue?vue&type=style&index=1&id=6b0a3ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a3ec6",
  null
  
)

export default component.exports